import { useMemo, useCallback } from 'react';
import { DetectedEvent } from '@ais-ui/websockets';
import { useSettings } from '../Settings/SettingsProvider';
import { useDateTimeFormat } from '../conversions/useDateFormat';
import {
  getEventFieldDisplayName,
  getEventFieldIcon,
} from '../Settings/Events';

export const useEventListExtraFields = () => {
  const { settings } = useSettings();
  const { formatDateTimeWithTimeZone } = useDateTimeFormat();

  const extraFields: string[] = useMemo(
    () => settings['ribbonPlugin.settings']?.event_list_extra_fields ?? [],
    [settings],
  );

  const getEventFieldValue = useCallback(
    (event: DetectedEvent, fieldKey: string): string => {
      switch (fieldKey) {
        case 'status':
          return event.deactivated ? 'Deactivated' : 'Activated';
        case 'severity':
          return event.severity
            ? event.severity.charAt(0).toUpperCase() + event.severity.slice(1)
            : '-';
        case 'activatedTime':
          return event.activated
            ? formatDateTimeWithTimeZone(event.activated)
            : '-';
        case 'deactivatedTime':
          return event.deactivated
            ? formatDateTimeWithTimeZone(event.deactivated)
            : 'Still active';
        case 'mmsi':
          return event.mmsi && event.mmsi > 0 ? String(event.mmsi) : '-';
        case 'imo':
          return event.imo || '-';
        case 'callSign':
          return event.callSign || '-';
        case 'acknowledged':
          return event.ack_state === 2 ? 'Yes' : 'No';
        default:
          return '-';
      }
    },
    [formatDateTimeWithTimeZone],
  );

  return {
    extraFields,
    getEventFieldValue,
    getEventFieldDisplayName,
    getEventFieldIcon,
  };
};
